module.exports = __webpack_public_path__ + "img/HeroBG_Mobile.735ecc1e.png";